/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Modal } from 'antd';

import { LoadingOutlined } from '@ant-design/icons';

import { verifyMFAToken } from '../redux/actions/Auth';

import Verify2FAForm from './Verify2FAForm';

const Verify2FA = (props) => {
  const dispatch = useDispatch();
  const { loading, message } = useSelector(({ auth }) => auth.verifyMFAToken);
  const form = useRef();
  const history = useHistory();

  const { visible, handleCancel } = props;

  const handleOk = () => {
    if (form.current) {
      form.current.validateFields().then((values) => {
        dispatch(verifyMFAToken(values));
      }).catch((error) => {
        console.error(error.errorFields);
      });
    }
  };

  useEffect(() => {
    if (message !== '') {
      history.push('/users');
    }
  }, [message, history]);

  return (
    (
      <Modal
        title="Verify Two Factor Authentication"
        open={visible}
        okText={loading ? (
          <>
            loading
            {' '}
            <LoadingOutlined />
          </>
        ) : 'Verify'}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ disabled: loading }}
        maskClosable={false}
      >
        <Verify2FAForm {...{ form }} />
      </Modal>
    )
  );
};

export default Verify2FA;
